/* eslint-disable react/prop-types */
import { useEffect } from 'react'

export default function PageSeo({ seo, path }) {
	useEffect(() => {
		// Declare the meta tags we manage in the app
		const allowedKeys = [
			'description',
			'keywords',
			'author',
			'og:title',
			'og:description',
			'og:image',
			'og:type',
			'og:url',
			'twitter:card',
			'twitter:title',
			'twitter:description',
			'twitter:image'
		]

		// --- CLEANUP EXISTING TAGS ---
		// Remove all tags we manage before applying new ones
		allowedKeys.forEach((name) => {
			const existingTag =
				document.querySelector(`meta[name="${name}"]`) ||
				document.querySelector(`meta[property="${name}"]`)
			if (existingTag) existingTag.remove()
		})

		// --- DETERMINE SEO CONTENT ---
		let finalTitle = seo?.title
		let finalMeta = seo?.meta || {}

		if (!seo) {
			// Fallback extraction
			const h1 = document.querySelector('h1')
			const h2 = document.querySelector('h2')
			const p = document.querySelector('p')

			finalTitle =
				h1?.innerText?.trim() ||
				h2?.innerText?.trim() ||
				document.title ||
				'Untitled Page'

			finalMeta.description =
				p?.innerText?.trim()?.slice(0, 160) ||
				`Learn more about ${finalTitle}.`

			finalMeta['og:title'] = finalTitle
			finalMeta['og:description'] = finalMeta.description
		}

		// --- APPLY TITLE ---
		if (finalTitle) document.title = finalTitle

		// --- APPLY META TAGS ---
		Object.entries(finalMeta).forEach(([name, content]) => {
			if (!name || !content) return
			if (!allowedKeys.includes(name)) return // skip undeclared ones

			let metaTag = document.createElement('meta')
			if (name.startsWith('og:') || name.startsWith('twitter:')) {
				metaTag.setAttribute('property', name)
			} else {
				metaTag.setAttribute('name', name)
			}
			metaTag.setAttribute('content', content)
			document.head.appendChild(metaTag)
		})
	}, [seo, path])

	return null
}
